<script>
    import {tick} from "svelte";
    import AssessmentFinding from './AssessmentFinding.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {capitalize} from "../lib/utils.js";
    import Prompt from '../Navigation/Prompt.svelte';
    import Form from '../Forms/Form.svelte';
    import Loader from '../Utilities/Loader.svelte';

    import {getObj, getObjects, saveObj, deleteObj} from '../lib/data.js';

    export let params;
    export let hosts = [];
    export let finding_type = params.finding_type;


    let severity_filter = null;
    let name_filter = "";

    let loading = true;
    let importing = false;
    let findingsImport = false;

    let delete_in_progress = false;

    let selected_finding;

    let uploadFields = [
        {
            name: "upload",
            type: "file"
        },
    ]

    if (finding_type == "burp") {
        uploadFields = [...uploadFields,
            {
                name: "combine",
                label: "Combine Issues?",
                type: "checkbox",
                dflt: true
            }
        ]
    }

    function custom_sort(a,b) {
        return b.finding_severity - a.finding_severity
    }


    async function getFindings(assessment_id, finding_type) {
        let filters = {
            assessment_id: assessment_id,
            finding_type: finding_type
        }
        loading = true;
        await tick()
        hosts = await getObjects("assessmentHosts", filters);
        loading = false;
    }

    async function selectFinding() {
        let id = this.dataset.id;

        selected_finding = await getObj("assessmentFinding", id)
    }

    async function deleteFinding() {
        if (delete_in_progress)
            return

        delete_in_progress = true;
        await deleteObj("assessmentFinding", selected_finding);

        await getFindings(params.assessment_id, finding_type);

        notifier.success("Finding Deleted")
        selected_finding = null;
        delete_in_progress = false;
    }

    function showFindingsImport() {
        findingsImport = true;
    }


    async function importFindings(form_data) {
        let url = `/assessments/${params.assessment_id}/${finding_type}`;
        console.log(form_data);
        if (form_data.detail.combine) {
            url += "?combine=1"
            console.log(url)
        }

        importing = true;
        let response = await fetch(url, {
            method: "POST",
            body: form_data.detail.upload[0]
        })

        if (response.status == 200) {
            notifier.success("Upload Completed Successfully");
            findingsImport = false;
        } else {
            notifier.danger("Upload Failed");
        }
        getFindings(params.assessment_id, finding_type);
        importing = false;
    }

    function filtersort(hosts, severity_filter, name_filter) {
        let filtered_hosts = JSON.parse(JSON.stringify(hosts));
        for (let host of filtered_hosts) {
            if (severity_filter != null) {
                host.findings = host.findings.filter((finding) => finding.finding_severity == severity_filter)
            }
            if (name_filter) {
                host.findings = host.findings.filter((finding) => finding.finding_name.toUpperCase().includes(name_filter.toUpperCase()))
            }
            host.findings = host.findings.sort(custom_sort);
        }

        return filtered_hosts;
    }

    function deleteHost(host) {
        if (confirm("Are you sure you want to delete this host and all associated issues?")) {
            deleteObj("assessmentHosts", host);
        }
        hosts = hosts.filter((h) => h.id != host.id);
        notifier.success("Host Deleted")
        selected_finding = undefined;
    }

    $: sorted_hosts = filtersort(hosts, severity_filter, name_filter)
    $: getFindings(params.assessment_id, finding_type);
</script>

<style>
    .columns {
        height: calc(100vh - 250px);
    }

    .column {
        height: 100%;
        overflow: auto;
    }

    .sev-icon {
        color: white;
        float:left;
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        margin-right: 10px;
        text-align:center;
    }

    .sev-icon.sev-3 {background-color: red;}
    .sev-icon.sev-2 {background-color: Orange;}
    .sev-icon.sev-1 {background-color: green;}
    .sev-icon.sev-0 {background-color: gray}
</style>


<h1 class="title is-1">{capitalize(finding_type)} Findings</h1>
<hr>

<div class="columns">
    <div class="column is-3 is-narrow">
        <div class="sticky menu">
           <p class="menu-label">Actions</p>
            <ul class="menu-list">
                <li><span class="link" on:click={showFindingsImport}>Import Findings</span></li>
                <li><a class="link" href="#/assessment/view/{params.assessment_id}">Return to Assessment</a></li>
            </ul>
            <p class="menu-label">Findings</p>
            {#if loading}
                <Loader />
            {:else}
            <ul class="menu-list">
                <li>
                    <div class="field">
                        <div class="control has-icons-left">
                            <input type="text" class="input is-rounded" placeholder="Search" bind:value={name_filter}>
                            <span class="icon is-small is-left">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>
                    </div>
                    Severity:
                    <div class="buttons has-addons is-centered">
                        <div class="button" class:is-info={severity_filter == null} on:click={() => severity_filter = null }>All</div>
                        <div class="button" class:is-light={severity_filter == 0} on:click={() => severity_filter = 0 }>Informational</div>
                        <div class="button" class:is-success={severity_filter == 1} on:click={() => severity_filter = 1 }>Low</div>
                        <div class="button" class:is-warning={severity_filter == 2} on:click={() => severity_filter = 2 }>Medium</div>
                        <div class="button" class:is-danger={severity_filter == 3} on:click={() => severity_filter = 3 }>High</div>
                    </div>
                </li>
                {#each sorted_hosts as host}
                    <li>
                        <span class="link">
                            {host.ip}
                            <span class="delete is-pulled-right" on:click={() => deleteHost(host)}></span>
                        </span>
                        <ul>
                            {#each host.findings as finding}
                            <li>
                                <span class="link" class:is-active={selected_finding && finding.id == selected_finding.id} data-id={finding.id} on:click={selectFinding}>
                                    <div class="sev-icon sev-{finding.finding_severity}">!</div>
                                    {finding.finding_name}
                                </span>
                            </li>
                            {/each}
                        </ul>
                    </li>
                {/each}
            </ul>
            {/if}
        </div>
    </div>
    <div class="column">
        {#if selected_finding}
            <h2 class="title is-2">
                {selected_finding.finding_name}
                <span class="button is-danger is-pulled-right" data-id={selected_finding.id} on:click={deleteFinding} class:is-loading={delete_in_progress}>Delete</span>
            </h2>
            <AssessmentFinding finding={selected_finding.finding_details} displayType={finding_type == "burp" ? "html" : "pre"} />
        {/if}
    </div>
</div>


{#if findingsImport}
    <Prompt prompt="Import Findings" on:close={() => findingsImport = false}>
        <form>
            <section class="modal-card-body">
                {#if importing}
                    <Loader />
                {:else}
                    <Form fields={uploadFields} on:submit={importFindings} />
                {/if}
            </section>
        </form>
    </Prompt>
{/if}